import { Component, Input, OnInit } from '@angular/core';
import { sessionStorageKey } from 'src/app/doctors-station/doctors-station.constants';
import { BaseLoginComponent } from 'src/app/shared/components/base-login/base-login.component';

@Component({
  selector: 'app-doctors-next-login-connect-cportal',
  templateUrl: './doctors-next-login-connect-cportal.component.html',
  styleUrls: [
    './doctors-next-login-connect-cportal.component.css',
    '../style/index.css',
  ],
})
export class DoctorsNextLoginConnectCportalComponent
  extends BaseLoginComponent
  implements OnInit
{
  @Input() password!: string;

  async init(): Promise<void> {
    setTimeout(() => {
      this.setEmail(
        sessionStorage.getItem(sessionStorageKey.doctorsNextCpIntegration.email)
      );
    }, 0);
  }

  async gotoLoginPage() {
    await this.router.navigate(['/login'], {
      queryParamsHandling: 'preserve',
      fragment: null,
    });
  }
}
